import { css } from 'styled-components'

export const CssGlobalVariable = css`
  :root {
    --show-arsa-keys-is-activated: false;
    --is-arsa-keys: false;
  }
`
